/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router';

export function useDocumentTitle(title) {
    useEffect(() => {
        document.title = title;
    }, [title]);

    return title;
}

export function SetDocumentTitle({ title, path }) {
    const location = useLocation();

    useEffect(() => {
        document.onreadystatechange = () => {
            document.title = title;
        };
    }, []);

    useEffect(() => {
        if (path === location.pathname) {
            document.title = title;
        }
    }, [location.pathname]);

    return null;
}

SetDocumentTitle.propTypes = {
    title: PropTypes.string,
    path: PropTypes.string,
};
useDocumentTitle.propTypes = {
    title: PropTypes.string,
};
